var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10492_12887)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 77.7505,
    width: 27,
    height: 42,
    rx: 3.5,
    fill: "#BAE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 77.7505H51C52.933 77.7505 54.5 79.3175 54.5 81.2505V116.25C54.5 118.183 52.933 119.75 51 119.75H49C47.067 119.75 45.5 118.183 45.5 116.25V77.7505Z",
    fill: "#93D4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 59.2505,
    width: 27,
    height: 60.5,
    rx: 3.5,
    fill: "#BED0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 59.2505H89.5C91.433 59.2505 93 60.8175 93 62.7505V116.25C93 118.183 91.433 119.75 89.5 119.75H87.5C85.567 119.75 84 118.183 84 116.25V59.2505Z",
    fill: "#8BACFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 29.7505,
    width: 27,
    height: 90,
    rx: 3.5,
    fill: "#81D9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5 29.7505H128C129.933 29.7505 131.5 31.3175 131.5 33.2505V116.25C131.5 118.183 129.933 119.75 128 119.75H126C124.067 119.75 122.5 118.183 122.5 116.25V29.7505Z",
    fill: "#1CC67F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 114.75,
    width: 128,
    height: 5,
    rx: 2.5,
    fill: "#BEE4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.498,
    y: 89,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.7383,
    y: 95.2598,
    width: 29.3333,
    height: 8.8,
    rx: 2,
    transform: "rotate(45 71.7383 95.2598)",
    fill: "#FF6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5156,
    y: 116.001,
    width: 29.3333,
    height: 8.8,
    rx: 2,
    transform: "rotate(-45 65.5156 116.001)",
    fill: "#FF6170"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10492_12887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3cfd9cc8a22d8eea1ea26a620baa0116.svg";
export { ForwardRef as ReactComponent };